module.exports = __webpack_public_path__ + "img/polycarbonate-panel.ded89f8.svg";